module.exports = __webpack_public_path__ + "img/magento-banner.d0075a11.jpg";